class Feature {
    hasAnyFeature(...features) {
        if (Array.isArray(features[0])) {
            features = features[0];
        }

        for (var feature of features) {
            if (this.hasFeature(feature)) {
                return true;
            }
        }

        return false;
    }

    hasFeature(feature) {
        return _.get(
            window.slurp,
            `auth.franchise.features.${feature}_enabled`,
            false,
        );
    }
}

const FeatureInstance = new Feature();

export default FeatureInstance;



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/feature.js